import React from 'react'
import SmallModal from '../../components/Modals/SmallModal'
import { Button, ButtonGroup, Box, Stack, Typography } from '@mui/material'
import API from '../../services/API'
import BigModal from '../../components/Modals/BigModal'

const OfferShift = ({ shiftID, onClose, open, loadAvailableShifts }) => {
  const handleSubmit = () => {
    API.post('/shifts/offer-for-reassignment', {
      shiftID,
    })
      .then((res) => {
        if (res.status === 200) {
          onClose()
          loadAvailableShifts()
        }
      })
      .catch((e) => console.error(e))
  }
  return (
    <BigModal autoWidth open={open} onClose={onClose}>
      <Stack alignItems="center" gap={1}>
        <Typography variant="title2" fontSize="1rem">
          Offer Shift for Reassignment
        </Typography>
        <Box maxWidth={400}>
          <Typography variant="caption" textAlign="center">
            If you can no longer work your assigned shift, you can offer it to
            colleagues on Available Shifts and your managers will be told.
            This does not remove you from the shift - you remain assigned and
            responsible for it until a manager accepts a colleague&apos;s
            application or reassigns it.
          </Typography>
        </Box>
        <Button
          onClick={() => onClose()}
          color="primary"
          variant="outlined"
          fullWidth
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="error"
          variant="contained"
          fullWidth
        >
          Offer Shift as Available
        </Button>
      </Stack>
    </BigModal>
  )
}

export default OfferShift
